import React from 'react';

const RoamingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 19.269 12" fill="#42a5f5">
    <g transform="translate(-121.171 -169.77)">
      <path d="M172.406,170.455c.244.173,1.856,1.428,3.088,2.378.961-.281,2.018-.589,3.051-.889-1.729-.811-4.3-1.973-4.679-2.058a2.663,2.663,0,0,0-1.586.009C171.749,170.047,172.072,170.218,172.406,170.455Z" transform="translate(-47.026 0)"/>
      <path d="M140.227,184.051a3.7,3.7,0,0,0-3.809-.81c-2.313.605-10.4,3-11.171,3.215a1.534,1.534,0,0,1-1.567-.221c-.382-.419-.964-1.012-1.114-1.164a1.112,1.112,0,0,0-1.077-.331c-.482.14-.292.692-.221.9.077.231.865,2.353,1.055,2.717.206.4.549,1.253,2.859.855,1.651-.284,3.561-.743,5.393-1.236.112-.362.2-.643.253-.794.134-.393,4.257-1.445,3.9-.8-.07.128-.159.287-.263.47,1.324-.4,2.4-.753,2.993-.953a18.052,18.052,0,0,0,2.794-1.05A.505.505,0,0,0,140.227,184.051Z" transform="translate(0 -12.294)"/>
      <path d="M228.623,225.062c-.739,1.348-3.542,6.109-3.957,6.554a3.182,3.182,0,0,1-1.572,1.059c-.634.213-.44-.166-.281-.616.173-.492,1.622-5.359,1.909-6.2C224.856,225.466,228.979,224.414,228.623,225.062Z" transform="translate(-93.895 -50.966)"/>
    </g>
  </svg>
);
export default RoamingIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/RoamingIcon.js